module.exports = __webpack_public_path__ + "static/media/favorito-no-seleccionado.ab12afc2.svg";